import {
	DocumentWorkflowInstanceSignatureStatus,
	InvestorDocumentWorkflowWitnessRes,
} from '@dealstack/shared/lib/generated';

export const deriveInvestorSignatureDisplayStatus = (
	primaryStatus: DocumentWorkflowInstanceSignatureStatus,
	witness: InvestorDocumentWorkflowWitnessRes | null | undefined
): DocumentWorkflowInstanceSignatureStatus => {
	const witnessOutstanding = witness != null && witness.signedCount < witness.requiredCount;
	if (primaryStatus === DocumentWorkflowInstanceSignatureStatus.SIGNED && witnessOutstanding) {
		return DocumentWorkflowInstanceSignatureStatus.WAITING_FOR_WITNESS_SIGNATURES;
	}
	return primaryStatus;
};
